<div cdk-overlay-origin #trigger class="select-container">
  <button
    type="button"
    class="select-trigger"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [disabled]="isDisabled()"
    [class.placeholder-visible]="placeholderVisible">
    {{ selectedLabel }}
  </button>
  @if (showClearButton) {
    <button
      type="button"
      class="select-clear"
      (click)="clearSelection($event)"
      aria-label="Clear selection">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  }
  <ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayMinWidth]="originWidth"
    (detach)="isOpen = false"
    (backdropClick)="isOpen = false"
    (overlayOutsideClick)="isOpen = false">
    <div class="select-dropdown" role="listbox">
      <!-- Search input for typeahead functionality -->
      @if (searchable()) {
        <div class="select-search">
          <app-input
            #searchInput
            [placeholder]="searchPlaceholder()"
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearchValueChange()"
            class="select-search-input">
          </app-input>
          @if (searchTerm.length > 0) {
            <app-button variant="ghost" (click)="clearSearch()" class="select-search-clear" aria-label="Clear search">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </app-button>
          }
        </div>
      }

      <!-- Loading state -->
      @if (isLoading()) {
        <div class="select-loading">Loading...</div>
      }

      <!-- No results message -->
      @if (!isLoading() && searchable() && isSearching && currentOptions.length === 0) {
        <div class="select-no-results">No results found</div>
      }

      <!-- Options list -->
      @if (!isLoading() && currentOptions.length > 0) {
        <div class="select-options">
          @for (option of currentOptions; track option; let i = $index) {
            <div
              class="select-option"
              [class.multi]="multi()"
              role="option"
              [class.highlighted]="isHighlighted(option)"
              [attr.aria-selected]="isSelected(option)"
              (click)="selectOption(option)"
              (mouseenter)="highlightedIndex = i">
              @if (multi()) {
                <input type="checkbox" class="select-checkbox" [checked]="isSelected(option)" />
              }
              {{ bindLabel() ? $any(option)[bindLabel()!] : option }}
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</div>
